// components/InfractionStatus.js
import React from "react";
import { Tag } from "antd";

const InfractionStatus = ({ status }) => {
  const getStatusConfig = (status) => {
    const config = {
      pending: { color: "orange", text: "Non Payé" },
      paid: { color: "green", text: "Payée" },
      canceled: { color: "red", text: "Annulée" },
    };
    return config[status] || { color: "default", text: status };
  };

  const { color, text } = getStatusConfig(status);
  return <Tag color={color}>{text}</Tag>;
};

export default InfractionStatus;
